// extracted by mini-css-extract-plugin
export var colorSquare = "_ue-0";
export var danger = "_ue-5";
export var lightPink = "_ue-8";
export var neutralBlue = "_ue-7";
export var neutralYellow = "_ue-6";
export var normal = "_ue-1";
export var primary = "_ue-2";
export var primaryLight = "_ue-3";
export var solidBlack = "_ue-g";
export var solidGreen = "_ue-b";
export var solidLightBlue = "_ue-d";
export var solidNavy = "_ue-c";
export var solidOrange = "_ue-f";
export var solidPink = "_ue-e";
export var solidRed = "_ue-9";
export var solidYellow = "_ue-a";
export var success = "_ue-4";